@if (hasRelatedRequests()) {
  <button
    type="button"
    name="relatedRequestsToggle"
    class="bg-transparent flex items-center gap-sm text-neutral-900 cursor-pointer"
    (mousedown)="toggleMenu($event)">
    <span class="text-xs font-medium whitespace-nowrap">
      {{
        'related_requests_count_label'
          | transloco: { count: relatedCount() }
      }}
    </span>
    <lib-chevron-down-icon
      [iconClass]="
        'size-4 text-primary-500 transition-transform ' +
        (isMenuOpen() ? 'rotate-180' : '')
      " />
  </button>
}

<div
  #menuOverlayContent
  class="hidden z-[2] w-[22.5rem] max-h-[24rem] flex flex-col bg-white shadow-xl rounded-lg gap-md py-lg px-lg">
  <div class="text-xs font-medium text-neutral-500">
    {{ 'related_requests_dropdown_title' | transloco }}
  </div>

  <div class="relative w-full">
    <input
      class="outline-0 border border-neutral-300 placeholder:text-neutral-500 text-sm p-md pe-3xl w-full rounded-md"
      type="text"
      [formControl]="searchControl"
      [placeholder]="'related_requests_search_placeholder' | transloco" />
    <lib-search-icon
      [iconClass]="'size-5 text-neutral-500 absolute end-md inset-y-[27.5%]'" />
  </div>

  <div class="overflow-x-hidden overflow-y-auto pe-sm w-full max-h-[16rem]">
    @let listItems = filteredChildFlows();
    @if (listItems.length) {
      @for (childFlow of listItems; track childFlow.id) {
        <div
          class="border-b border-neutral-200 last:border-b-0 w-full flex items-start gap-md py-md">
          <div
            class="shrink-0 size-8 rounded-full bg-primary-50 flex items-center justify-center">
            <lib-workflow-icon [iconClass]="'size-4 text-primary-500'" />
          </div>

          <div class="min-w-0 flex-1 flex flex-col gap-sm">
            <div class="flex items-start justify-between gap-sm">
              <span
                libTrimTooltip
                placement="top"
                position="fixed"
                [trimLength]="28"
                [hasCloseIcon]="false"
                [toolTipClass]="
                  'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top w-[20rem] text-balance !z-[10050]'
                "
                [fullText]="childFlow.displayName"
                class="min-w-0 text-neutral-900 font-medium text-xs truncate">
                {{ childFlow.displayName }}
              </span>

              @if (childFlow.stateLabel) {
                <lib-badge
                  [label]="childFlow.stateLabel"
                  [badgeClass]="
                    'shrink-0 px-sm border-none text-xs font-medium ' +
                    childFlow.statusBadgeClass
                  " />
              }
            </div>

            <a
              [routerLink]="childFlow.viewLink"
              class="inline-flex items-center gap-xs text-xs font-medium text-primary-500 hover:underline w-fit"
              (click)="$event.stopPropagation()">
              {{ 'view_details_button' | transloco }}
              <lib-chevron-right-icon
                [iconClass]="'size-3.5 text-primary-500 rtl:rotate-180'" />
            </a>
          </div>
        </div>
      }
    } @else {
      <div class="py-2xl px-lg text-center text-xs text-neutral-500">
        {{ 'no_search_result_label' | transloco }}
      </div>
    }
  </div>
</div>
